module.exports = __webpack_public_path__ + "static/Matthias-Hauswirth-627f279d050c139b8d7f92ee85bce1c7.jpg";